<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Venues</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row align-items-center">
              <div class="col-8">
                <h3 class="mb-0" id="users_main_heading">Users</h3>
              </div>
              <div class="col-2 text-right">
                <div class="deactive-user-button">
                  <label class=" col-form-label form-control-label pr-3 text-danger" style="vertical-align: super">Active Only</label>
                  <base-switch v-model="showActiveOnlyUsers"></base-switch>
                </div>
              </div>
              <div class="col-2 text-right">
                <a @click.stop="toCreateUserPage"  class="btn btn-primary create_user_button">Create User</a>
              </div>
            </div>
          </template>
          <div>
            <div class="col-12 text-right">
              <div>
                <base-input
                  id="search_input"
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                />
              </div>
            </div>

            <el-table
              :data="tableData"
              row-key="id"
              id="users_data_table"
              v-loading="loading"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @row-click="rowClicked"
            >
              <el-table-column label="ID" prop="user_id" sortable="">
                <template v-slot="{ row }">
                  {{ row.user_id }}
                </template>
              </el-table-column>
              <el-table-column
                label="Name"
                min-width="220px"
                prop="display_name"
                sortable
              >
                <template v-slot="{ row }">
                  <div class="media align-items-center">
                    <div class="media-body">
                      <span class="font-weight-600 name mb-0 text-sm">{{
                        row.display_name
                      }}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Username" prop="username" sortable>
                <template v-slot="{ row }">
                  {{ row.username }}
                </template>
              </el-table-column>
              <el-table-column label="Email" prop="email" min-width="250px">
                <template v-slot="{ row }">
                  {{ row.email }}
                </template>
              </el-table-column>
              <el-table-column label="VC Role" prop="vc_role">
                <template v-slot="{ row }">
                  {{ row.vc_role }}
                </template>
              </el-table-column>
              <el-table-column label="User Role" prop="role" sortable>
                <template v-slot="{ row }">
                  {{ row.role }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Loading } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import tableMixin from "@/helpers/tableMixin";

export default {
  mixins: [tableMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      propsToSearch: "username",
      loading: true,
      showActiveOnlyUsers: true,
    };
  },
  async created() {
    await this.$store.dispatch("users/getAll");
    this.loading = false;
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/isAdministrator"];
    },
    queriedData() {
      let data =  [...this.$store.state.users.items];
      let isAdmin = this.isAdmin;
      data = data.filter(function(item) {
        if (!isAdmin && item.role === 'administrator') {
          return false;
        }
        return true;
      });
      if (this.searchQuery) {
        const propsToSearch = this.propsToSearch;
        const searchQuery = this.searchQuery;
        data = data.filter(function(item) {
          return item[propsToSearch].toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1;
        });
      }
      if(this.showActiveOnlyUsers) {
        data = data.filter(function(item) {
          return !item.user_disabled;
        });
      }
      return data;
    },
    tableData() {
      let data = [...this.queriedData];
      data = data.slice(this.from, this.from + this.pagination.perPage);
      return data;
    },
  },
  methods: {
    rowClicked(row) {
      this.$router.push({ name: 'UserDetails', params: {id: row.user_id} });
    },
    toCreateUserPage() {
      this.$router.push({ name: 'CreateNewUser'});
    },
  },
};
</script>

<style>
.no-border-card .card-footer {
  border-top: 0;
}
.el-table .cell {
  word-break: normal;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f6f9fc !important;
  cursor: pointer;
}
</style>
